import React from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import { getOrgTermsContent } from '../../../content/utils.js';
import CustomizeStakeholderAnalysisIcon from '../../icons/CustomizeStakeholderAnalysisIcon.jsx';
import DownloadCsvTableIcon from '../../icons/DownloadCsvTableIcon.jsx';
import DownloadReportIcon from '../../icons/DownloadReportIcon.jsx';
import { StakeholdersSettingsLink } from '../../links/index.jsx';
import CustomMenuItem from '../../CustomMenuItem.jsx';

const StakeholdersActionsDropdown = ({
  projectId,
  project,
  stakeholders,
  onDownloadReport,
  onDownloadCsv,
  isCsvLoading,
  isReportLoading,
}) => {
  return (
    <div className="actions">
      <DropdownButton
        noCaret
        title=""
        id="id"
        className="btn-more btn btn-default"
      >
        {project.archived ? (
          <>
            <CustomMenuItem
              onClick={() =>
                window.alert(getOrgTermsContent('archivedProjectMessage'))
              }
            >
              <span className="flex">
                <CustomizeStakeholderAnalysisIcon />
                <span className="m-l-8">
                  &nbsp; Customize Stakeholder Analysis
                </span>
              </span>
            </CustomMenuItem>
            <MenuItem divider />
          </>
        ) : (
          <StakeholdersSettingsLink projectId={projectId}>
            <CustomMenuItem>
              <span className="flex">
                <CustomizeStakeholderAnalysisIcon />
                <span className="m-l-8">Customize Stakeholder Analysis</span>
              </span>
            </CustomMenuItem>
            <MenuItem divider />
          </StakeholdersSettingsLink>
        )}

        {stakeholders.length ? (
          <React.Fragment>
            <CustomMenuItem>
              <button
                className="flex flex-align-center w-100 h-100 p-0 btn-clear bg-transparent"
                disabled={isCsvLoading}
                onClick={onDownloadCsv}
              >
                <DownloadCsvTableIcon />
                &nbsp;
                <span className="m-l-8">
                  {isCsvLoading ? 'Loading...' : 'Download CSV Table'}
                </span>
              </button>
            </CustomMenuItem>
            <CustomMenuItem divider />

            <CustomMenuItem>
              <button
                className="flex flex-align-center w-100 h-100 p-0 btn-clear bg-transparent"
                disabled={isReportLoading}
                onClick={onDownloadReport}
              >
                <DownloadReportIcon />
                <span className="m-l-12">
                  {isReportLoading ? 'Loading...' : 'Download Report'}
                </span>
              </button>
            </CustomMenuItem>
          </React.Fragment>
        ) : null}
      </DropdownButton>
    </div>
  );
};

export default StakeholdersActionsDropdown;
